export default __webpack_public_path__ + "static/media/times.e6571c17.svg";